import * as React from 'react';
import { Translate } from '../../../../shared/LanguageService';
import { IPhotographerInvoice } from './SinglePhotographerInvoiceTypes';
import { Row, Col } from 'react-bootstrap';

interface IProps {
    invoice: IPhotographerInvoice;
    key: number;
    view: (invoice: IPhotographerInvoice) => void;
    rejected: boolean;
}

const InvoiceListRow = (props: IProps) => {
    return (
        <Row>
            <Col sm={12} md={6}>
                <a onClick={() => props.view(props.invoice)} className="alink">
                    {props.invoice.name}
                </a>
            </Col>
            {props.rejected && (
                <Col sm={4} md={2}>
                    <span className="status-icons">
                        <i
                            title={Translate('photographer-invoice/list/rejection-marker/title')}
                            className="material-icons color-body color-danger-bg"
                        >
                            cancel
                        </i>
                    </span>
                </Col>
            )}
        </Row>
    );
};

export default InvoiceListRow;
